"use strict";

var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _uploadConfig = _interopRequireDefault(require("../uploadConfig"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var PDF_MIME_TYPE = 'application/pdf';
var getCorrectUrlFromUpload = function getCorrectUrlFromUpload(uploadsUrlBuilder, upload) {
  if ((0, _includes2["default"])(_uploadConfig["default"].imageTypes, upload.type)) {
    return uploadsUrlBuilder.getImageUploadUrl();
  }
  if ((0, _includes2["default"])(_uploadConfig["default"].fileTypes, upload.type)) {
    return uploadsUrlBuilder.getFileUploadUrl();
  }
  if ((0, _includes2["default"])((0, _keys2["default"])(_uploadConfig["default"].fileUploadTypes), upload.name.substring(upload.name.lastIndexOf('.'), upload.name.length))) {
    return uploadsUrlBuilder.getFileUploadUrl();
  }
  if (upload.type === PDF_MIME_TYPE) {
    return uploadsUrlBuilder.getPdfUploadUrl();
  } // default to file upload if file type is unsupported or not existing in the uploadConfig

  return uploadsUrlBuilder.getFileUploadUrl();
};
var getFileExtensionFromFile = function getFileExtensionFromFile(uploadName) {
  return uploadName.substring(uploadName.lastIndexOf('.'), uploadName.length);
};
var isSupportedFile = function isSupportedFile(upload) {
  // exclude AI files, becuase it causing issues in BACO
  if ((0, _includes2["default"])((0, _keys2["default"])(_uploadConfig["default"].excludedFileTypes), getFileExtensionFromFile(upload.files[0].name))) {
    return;
  }
  return (0, _includes2["default"])(_uploadConfig["default"].imageTypes, upload.files[0].type) || (0, _includes2["default"])(_uploadConfig["default"].fileTypes, upload.files[0].type) || (0, _includes2["default"])((0, _keys2["default"])(_uploadConfig["default"].fileUploadTypes), getFileExtensionFromFile(upload.files[0].name));
};
module.exports = {
  getCorrectUrlFromUpload: getCorrectUrlFromUpload,
  isSupportedFile: isSupportedFile,
  getFileExtensionFromFile: getFileExtensionFromFile
};